//components
import {
  SectionWrap,
  Kicker,
  KickerDot,
  SectionTitle,
  Grad,
} from '@/containers-ai/SectionHeading';

//theme
import { homeColor } from '@/theme/ai';

//styles
import {
  StackSection,
  StackWrap,
  StackDescription,
  DiagramWrap,
  DiagramSvg,
} from './RunsOnYourStack.styles';

const integrations = [
  {
    key: 'API',
    copy: 'Connects to your system of record over a direct API integration.',
  },
  {
    key: 'EDI',
    copy: 'Speaks EDI where your carriers and partners already do.',
  },
  {
    key: 'MCP',
    copy: 'Exposes the same actions over MCP for agent-to-agent workflows.',
  },
];

export function RunsOnYourStack() {
  const rowY = [50, 110, 170];

  return (
    <StackSection>
      <SectionWrap>
        <StackWrap>
          <Kicker>
            <KickerDot />
            Runs on your stack
          </Kicker>
          <SectionTitle style={{ maxWidth: 'none' }}>
            Nothing to rip out. <Grad>Nothing to migrate.</Grad>
          </SectionTitle>
          <StackDescription>
            Your existing systems stay your system of record. Loadsmart
            becomes your system of action &mdash; the work runs on the
            Loadsmart Platform and the outcome is written back where your team
            already looks for it.
          </StackDescription>
        </StackWrap>
        <DiagramWrap>
          <DiagramSvg
            viewBox="0 0 1000 220"
            role="img"
            aria-label="Your system of record connects to Loadsmart AI over API, EDI, and MCP."
          >
            <rect
              x="0"
              y="70"
              width="180"
              height="80"
              rx="10"
              fill={homeColor.surface2}
              stroke={homeColor.cyan}
              strokeWidth="1.9"
            />
            <text
              x="90"
              y="102"
              textAnchor="middle"
              fontFamily="Manrope,system-ui,sans-serif"
              fontWeight="700"
              fontSize="11"
              fill="#FCFCFF"
            >
              YOUR SYSTEM OF
            </text>
            <text
              x="90"
              y="116"
              textAnchor="middle"
              fontFamily="Manrope,system-ui,sans-serif"
              fontWeight="700"
              fontSize="11"
              fill="#FCFCFF"
            >
              RECORD
            </text>
            <text
              x="90"
              y="134"
              textAnchor="middle"
              fontFamily="Manrope,system-ui,sans-serif"
              fontWeight="500"
              fontSize="11"
              fill={homeColor.muted2}
            >
              TMS &middot; WMS &middot; ERP
            </text>

            <rect
              x="820"
              y="70"
              width="180"
              height="80"
              rx="10"
              fill={homeColor.surface}
              stroke={homeColor.cyan}
              strokeWidth="1.9"
            />
            <text
              x="910"
              y="112"
              textAnchor="middle"
              fontFamily="Manrope,system-ui,sans-serif"
              fontWeight="700"
              fontSize="16"
              fill="#fff"
            >
              Loadsmart AI
            </text>
            <text
              x="910"
              y="130"
              textAnchor="middle"
              fontFamily="Manrope,system-ui,sans-serif"
              fontWeight="500"
              fontSize="10"
              fill={homeColor.green}
            >
              Agents running the work
            </text>

            {integrations.map((row, index) => {
              const y = rowY[index];
              return (
                <g key={row.key}>
                  <line
                    x1="180"
                    y1={y}
                    x2="820"
                    y2={y}
                    stroke={homeColor.muted2}
                    strokeWidth="1"
                    strokeDasharray="3 4"
                    opacity="0.6"
                  />
                  <circle cx="180" cy={y} r="3.5" fill={homeColor.muted2} />
                  <circle cx="820" cy={y} r="3.5" fill={homeColor.muted2} />
                  <rect
                    x="270"
                    y={y - 15}
                    width="460"
                    height="30"
                    rx="15"
                    fill={homeColor.bg}
                    stroke="rgba(0,215,215,0.4)"
                    strokeWidth="1"
                  />
                  <text
                    x="292"
                    y={y + 4}
                    fontFamily="Manrope,system-ui,sans-serif"
                    fontWeight="600"
                    fontSize="11"
                    fill={homeColor.green}
                  >
                    {row.key}
                  </text>
                  <text
                    x="330"
                    y={y + 4}
                    fontFamily="Manrope,system-ui,sans-serif"
                    fontWeight="500"
                    fontSize="11"
                    fill={homeColor.muted}
                  >
                    {row.copy}
                  </text>
                </g>
              );
            })}
          </DiagramSvg>
        </DiagramWrap>
      </SectionWrap>
    </StackSection>
  );
}
